class RecipePrintController {
    constructor($timeout) {
        $timeout(() => window.print(), 0);
    }
}

const recipePrintComponentDefinition = {
    bindings: {
        recipe: '<',
    },
    controller: ['$timeout', RecipePrintController],
    template: require('./recipe-print.component.html').trim(),
};

module.exports = {
    RecipePrintController,
    recipePrintComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/recipe/recipe-print/recipe-print.component.js